import {Api} from './user-gw';
import {loadStateFromLS} from '@app/context';
import {latestCheckStorage} from '@services/latestCheckStorage';
import {userStorage} from '@app/user';
import {tokenStorage} from '@app/token';
import {isSystemErrorStatus, redirectToSystemError} from '@utils/systemError';

export const CApi = () => {
    const api = new Api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: {Authorization: `Bearer ${loadStateFromLS().token}`},
        withCredentials: true
    });

    api.instance.interceptors.response.use(
        // Success response handler
        (response) => {
            // console.log('Response received:', response.data);
            // You can modify the response here
            return response;
        },
        // Error response handler
        (error) => {
            // console.error('Response error:', error);

            if (error.response) {
                // Server responded with error status
                const {status} = error.response;

                switch (status) {
                    case 401:
                        // Handle unauthorized - redirect to the login page
                        localStorage.removeItem('at.ug.token');
                        window.location.href = '/login';
                        break;
                    default:
                        if (isSystemErrorStatus(status)) {
                            redirectToSystemError(status, error);
                        }
                }
            } else if (error.request) {
                // Network error
                // console.error('Network error - no response received');
                if (error.code === 'ERR_NETWORK' && window.location.href.includes('test.atez.ru')) {
                    const currentTimestamp = Date.now(); // Current time in seconds
                    const fiveMinutesAgo = currentTimestamp - 5 * 60 * 1000;
                    let lastCheckTimestamp = latestCheckStorage.get();
                    //console.log('lastCheckTimestamp', lastCheckTimestamp);
                    //console.log('fiveMinutesAgo', fiveMinutesAgo);
                    if (!lastCheckTimestamp || lastCheckTimestamp < fiveMinutesAgo) {
                        userStorage.clear();
                        tokenStorage.clear();
                        //console.log('logout');
                        //console.log('redirect to /');
                        window.location.href = '/login';
                        return Promise.reject(error);
                    } else {
                        //console.log('redirect to atez.ru');
                        window.location.href = 'https://atez.ru';
                    }
                }
            }

            return Promise.reject(error);
        }
    );

    return api;
};
